import useRenderFromTemplate, {
	IUseRenderFromTamplateProps
} from 'src/hooks/useRenderFromTemplate';
import { extractFunctions } from 'src/common/helpers/extractFunctions';
import { handleFunctions } from 'src/common/helpers/handleFunctions';

type Props = object & IUseRenderFromTamplateProps;

export default function useRenderRenderComponents({ template, view, }: Props) {
	const rendered = useRenderFromTemplate({ template, view, });

	const extracted = extractFunctions(rendered);

	const ids = extracted.map(_ => window.crypto.randomUUID());

	const result = handleFunctions(extracted, rendered, ids);

	return result;
}
